import React from 'react';
import FlowList from '@components/acca/introduce/flowStory/flowList';
import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './interview.module.scss';
const cx = classnames.bind(styles);

interface FlowStoryProps {
  fadeIn: boolean;
}

const Interview = ({ fadeIn }: FlowStoryProps) => {
  return (
    <div className={cx('commonBox', { on: fadeIn })}>
      <div className={cx('mainTitle')}>
        <p className={cx('light')}>이미 1,109,106명의 선배들이</p>
        JOBDA 역량검사로 취업을 준비했어요.
      </div>
      <Link href={RouteUrl.INFO_LIST} legacyBehavior>
        <a role="button" target="_blank" className={cx('btnBlack', 'btnIcon')}>
          취업 합격후기 확인하기
        </a>
      </Link>
      <FlowList />
    </div>
  );
};

export default Interview;
